<template>
  <div class="footer">
    <div class="footer_center">
      <div class="content">
        <div class="icon_text">
          <img src="@/assets/img/public/537@2x.png" />
          <span>五天无理由退款</span>
        </div>
        <div class="icon_text">
          <img src="@/assets/img/public/538@2x.png" />
          <span>备案补偿</span>
        </div>
        <div class="icon_text">
          <img src="@/assets/img/public/536@2x.png" />
          <span>1V1大客户服务</span>
        </div>
        <div class="icon_text">
          <img src="@/assets/img/public/540@2x.png" />
          <span>7*24小时服务</span>
        </div>
      </div>
      <div class="separate"></div>
      <div class="information">
        <ul class="one">
          <li>产品方案</li>
          <li>私域流量运营平台</li>
          <li>全渠道营销平台</li>
          <li>业务中台</li>
          <li>数据中台</li>
          <li>&nbsp;</li>
        </ul>
        <ul class="two">
          <li></li>
          <li>小程序商城</li>
          <li>POS智能收银</li>
          <li>&nbsp;</li>
          <li>&nbsp;</li>
          <li>&nbsp;</li>
        </ul>
        <ul class="three">
          <li>解决方案</li>
          <li>母婴行业解决方案</li>
          <li>美妆行业解决方案</li>
          <li>私欲流量运营</li>
          <li>全渠道营销</li>
          <li>&nbsp;</li>
        </ul>
        <ul class="last">
          <li>联系我们</li>
          <li>地址：广州市天河区建工路南天大厦308</li>
          <li>邮箱：marketing@ky-cloud.com</li>
          <li><img src="@/assets/img/public/539@2x.png" class="img" /></li>
          <li>&nbsp;</li>
          <li>&nbsp;</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.footer {
  height: 380px;
  padding-top: 100px;
  background-color: #262c3b;

  .footer_center {
    margin: 0 auto;
    width: 1200px;

    .content {
      text-align: left;
      .icon_text {
        display: inline-block;
        margin-right: 248px;

        img {
          cursor: pointer;
          float: left;
          width: 32px;
          height: 32px;
          margin-right: 10px;
        }
        span {
          cursor: pointer;
          float: left;
          margin: 12px 0;
          color: #a2a5aa;
        }
      }
      .icon_text:last-child {
        margin-right: 0;
      }
    }

    .separate {
      width: 100%;
      height: 1px;
      margin: 15px 0 30px 0;
      background-color: #515b6b;
    }
    .information {
      text-align: left;
      color: #a2a5aa;
      ul {
        width: 100px;
        padding: 0;
        margin: 0;
        display: inline-block;
        list-style: none;

        li {
          cursor: pointer;
          font-size: 12px;
          text-align: left;
          height: 30px;
          line-height: 30px;
        }
        li:first-child {
          font-size: 16px;
          color: #d9dce5;
        }
        .img {
          width: 32px;
          height: 32px;
        }
      }
      .one {
        margin-right: 50px;
      }
      .two {
        margin-right: 125px;
      }
      .three {
        margin-right: 240px;
      }
      .last {
        width: 480px;
      }
    }
  }
}
</style>
